import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=fa35d804"
import script from "./Checklist.vue?vue&type=script&lang=js"
export * from "./Checklist.vue?vue&type=script&lang=js"
import style0 from "./Checklist.vue?vue&type=style&index=0&id=fa35d804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports